<template>
    <div id="transactionCompletePage">
        <div class="d-flex flex-column rounded align-items-center text-center py-4 px-lg-5 px-3 bg-white">
            <div class="lazada-hc-logo"></div>
            <div class="d-flex flex-column align-items-center text-center p-2">
                <img alt="" src="/img/lazada/technical-issue-icon.svg" class="img-responsive">
                <span class="font-md font-weight-bold my-3">
                    Unable to process your payment
                </span>
                <span class="font-sm text-secondary margin-bottom">
                    This is usually because of a temporary system error. Please try again later.
                </span>
                <span class="font-sm text-secondary text-danger cancel-margin-bottom">
                    Reference No. {{ this.$root.$data.referenceNumber }}
                </span>
                <div class="col-lg-11 col-xs-12 d-flex flex-column align-items-center">
                    <button type="button" @click="mobileSubmitBtn" class="btn btn-success btn-lg btn-block rounded-lg font-sm text-capitalize font-weight-bold mb-5 padding-y">
                        Back to Lazada
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import embed_video from '../../components/embed_video.vue';
export default {
  components: { embed_video },
    created() {
        let g4Params = {
            'userId': this.$root.$data.account.userId,
            'cuid': this.$root.$data.account.cuid,
            'ip': this.$root.transaction.ipAddress,
            'user_agent': this.$root.$data.analyticsData.userAgent,
            'phone': this.$root.$data.analyticsData.phone,
            'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
            'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
            'transaction_type': 'WT',
            'transaction_reference': this.$root.$data.referenceNumber,
        }       
        this.$root.triggerG4Event('err_system_error',g4Params)
    
    },
    methods: {
        mobileSubmitBtn() {
            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': 'WT',
                'transaction_reference': this.$root.$data.referenceNumber,
            }       
            this.$root.triggerG4Event('err_system_error_click_back_to_lazada',g4Params)
             window.location.href = "https://pages.lazada.com.ph/wow/gcp/route/lazada/ph/upr_1000345_lazada/channel/ph/upr-router/render?hybrid=1&data_prefetch=true&prefetch_replace=1&at_iframe=1&wh_pid=/lazada/channel/ph/lazada-wallet-loans/LazadaLoans";
        }
    }
    
}
</script>
<style scoped>
    .transactionCompleteIcon {
        height: auto;
        width: 7rem;
    }
    .lazada-hc-logo {
        /* Layout Properties */
        top: 14px;
        left: 36px;
        width: 100%;
        height: 52px;
        margin-bottom: 41px;
        /* UI Properties */
        background: transparent url('/img/lazada/logos_desktop.png') center no-repeat padding-box;
        opacity: 1;
    }
    .padding-y {
        padding: 16px 0 16px;
    }
    .cancel-margin-bottom {
        margin-bottom: 80px;
    }
    .margin-bottom {
        margin-bottom: 24px;
    }
</style>